import { render } from "./AppTextWrapper.vue?vue&type=template&id=5f5e5d9f&scoped=true"
import script from "./AppTextWrapper.vue?vue&type=script&lang=js"
export * from "./AppTextWrapper.vue?vue&type=script&lang=js"

import "./AppTextWrapper.vue?vue&type=style&index=0&id=5f5e5d9f&scoped=true&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5e5d9f"]])

export default __exports__